import React, { useEffect, useState } from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import DataService from "../../Service";

import {
  Select,
  FormControl,
  FormHelperText,
  MenuItem,
  Grid,
  Typography,
} from "@material-ui/core";
import MultiSelectChip from "./multi_select_chip";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      width: "100%",
    },
    inputLabel: {
      paddingLeft: "14px",
      marginTop: "-8px",
      color: "#a9a9a9",
    },
    gridRoot: {
      flexGrow: 1,
      marginBottom: "20px",
    },
  })
);

export const DatePickerSelect = (props: any) => {
  const classes = useStyles();
  const {
    label,
    type,
    selectOptions,
    name,
    placeholder,
    placeholder1,
    required,
    defaultValue,
    disabled,
    readOnly,
    error,
    helperText,
    autoComplete,
    autoFocus,
    classNames,
    rows,
    rowsMax,
    color,
    value,
    apiVariable,
    params,
    handleChange,
    index,
    // selectValue
  } = props.componentObject;
  return (
    <FormControl
      size="small"
      variant={"outlined"}
      className={classes.formControl}
    >
      {(props.selectValue === undefined ||
        (props.selectValue && props.selectValue.length === 0)) && (
        <InputLabel
          shrink={false}
          className={classes.inputLabel}
          id="demo-simple-select-outlined-label"
        >
          <Typography variant="h2">{placeholder}</Typography>
        </InputLabel>
      )}
      <Select
        name={name}
        displayEmpty
        disabled={disabled}
        style={
          props.selectValue === "Yes" ? { padding: "6px" } : { padding: "" }
        }
        value={props.selectValue === null ? placeholder : props.selectValue}
        onChange={(e) => {
          props.setSelectValue(e.target.value);
          handleChange("removeSelect", "", "", "", e.target.value);
        }}
      >
        {/* <span style={{paddingLeft: '10px', color: 'gray'}}>{placeholder}</span> */}
        <MenuItem
          disabled
          value=""
          style={{
            color: "#808080",
            opacity: 1,
          }}
        >
          <Typography variant="h2">{placeholder}</Typography>
        </MenuItem>
        {selectOptions.map((option: any, index: any) => {
          return (
            <MenuItem key={option.id} value={option.value}>
              <Typography variant="h2">{option.name}</Typography>
            </MenuItem>
          );
        })}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default function SelectWithMultiSelect(props: any) {
  const classes = useStyles();
  const { label, componentType, value, itemArr1, name1 } =
    props.componentObject;
  const [selectValue, setSelectValue] = useState("No");
  const { componentObject, selectedOptions } = props;

  useEffect(() => {
    setSelectValue(value?.length ? "Yes" : "No");
  }, [value]);

  const handleInputChange = (value: any) => {
    setSelectValue(value);
  };

  return (
    <Grid container className={classes.gridRoot}>
      <Grid xs={12} md={4}>
        {label}
      </Grid>
      {componentType === "selectWithMultiSelect" && (
        <Grid xs={12} md={selectValue === "Yes" ? 2 : 7}>
          <DatePickerSelect
            componentObject={props.componentObject}
            setSelectValue={setSelectValue}
            selectValue={selectValue}
          />
        </Grid>
      )}
      &nbsp;{" "}
      {componentType === "selectWithMultiSelect" && (
        <Grid xs={12} md={5}>
          {selectValue === "Yes" ? (
            //   <MultiSelectChip componentObject={props.componentObject} selectValue={selectValue} />
            <Grid container style={{ marginBottom: 20 }}>
              <Grid item xs={12} md={12}>
                <MultiSelectChip
                  style={{ padding: 4 }}
                  // id={componentObject.id}
                  name={name1}
                  // value={value}
                  componentObject={props.componentObject}
                  itemArr={itemArr1}
                  id={componentObject.id}
                  // parentcall={onChangeMultiItem}
                  placeholder={componentObject.placeholder1}
                  value={componentObject.value}
                  // placeholder={componentObject.placeholder}
                />
              </Grid>
            </Grid>
          ) : (
            []
          )}
        </Grid>
      )}
    </Grid>
  );
}
